import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Register from "./components/Register";
import VerifyOtp from "./components/VerifyOtp";
import Dashboard from "./components/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import RequireGuest from "./components/RequireGuest";
import Login from "./components/Login";
import AllShifts from "./components/AllShifts";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" 
            element={
              <RequireGuest>
                <Register />
              </RequireGuest>
            }
          />
          <Route path="/verify" 
            element={
              <RequireGuest>
                <VerifyOtp />
              </RequireGuest>
            }
          />
          <Route path="/login" 
            element={
              <RequireGuest>
                <Login />
              </RequireGuest>
            }
          />
          <Route path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
            } 
          />
          <Route path="/shifts" 
          element={
            <ProtectedRoute>
              <AllShifts />
            </ProtectedRoute>
            } 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
